export class GooglePickerTimeoutError extends Error {
  constructor() {
    super('Google picker initialization timed out')
  }
}
